import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Amplify3Page() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    marketing: false,
    honeypot: '' // Hidden field for bot detection
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await fetch('/amplify3-handler.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        // Set session access for download page
        sessionStorage.setItem('amplify3-access', 'true');
        sessionStorage.setItem('amplify3-email', formData.email);

        // Navigate to download page
        navigate('/amplify3/download');
      } else {
        setError(result.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-section-wrapper">
          <div className="page-section-header">
            <h1>Amplify 3<span className="trademark">™</span></h1>
          </div>

        <p>A framework for artists who need a plan, not just inspiration.</p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="name">Name (Optional)</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your name"
              disabled={isSubmitting}
            />
          </div>

          {/* Honeypot field - hidden from humans, filled by bots */}
          <div style={{ position: 'absolute', left: '-9999px' }}>
            <label htmlFor="website">Website</label>
            <input
              type="text"
              id="website"
              name="honeypot"
              value={formData.honeypot}
              onChange={handleChange}
              tabIndex="-1"
              autoComplete="off"
            />
          </div>

          <button type="submit" className="btn" disabled={isSubmitting} style={{ marginBottom: '1.5rem' }}>
            {isSubmitting ? 'Sending...' : 'Get Free Download'}
          </button>

          {error && (
            <div className="form-status error" style={{ display: 'block', marginBottom: '1.5rem' }}>
              {error}
            </div>
          )}

          <div className="checkbox-group" style={{ marginTop: 0 }}>
            <input
              type="checkbox"
              id="marketing"
              name="marketing"
              checked={formData.marketing}
              onChange={handleChange}
              disabled={isSubmitting}
            />
            <label htmlFor="marketing">
              Yes, I want to receive occasional updates about art, design, and the Amplify 3™ framework from DYAR.
            </label>
          </div>
        </form>

        <div className="a3-personal-message">
          <p>
            <strong>I hate spam</strong> as much as you do, probably more. I've spent decades in tech and I know exactly how this game is played. So it goes without saying that I'll never sell or share your info. When I do reach out, it'll be because it actually matters.
          </p>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Amplify3Page;
